import { render, staticRenderFns } from "./DriverInvoiceDetail.vue?vue&type=template&id=748c427e&scoped=true&"
import script from "./DriverInvoiceDetail.vue?vue&type=script&lang=js&"
export * from "./DriverInvoiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./DriverInvoiceDetail.vue?vue&type=style&index=0&id=748c427e&scoped=true&lang=css&"
import style1 from "./DriverInvoiceDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748c427e",
  null
  
)

export default component.exports